import { GeometryRenderConfigInterface } from 'modules/construction-work/src/Common/interface';

export const MARKER_CONFIGS: Record<string, GeometryRenderConfigInterface> = {
    polygon: {
        markerWidth: 40,
        markerHeight: 52,
        notificationSize: 25,
        notificationOffset: {dx: 15, dy: -38},
    },
    marker: {
        markerWidth: 40,
        markerHeight: 52,
        notificationSize: 25,
        notificationOffset: {dx: 15, dy: -38},
    },
    lineString: {
        markerWidth: 40,
        markerHeight: 52,
        notificationSize: 25,
        notificationOffset: {dx: 15, dy: -38},
        markerOffset: {dy: 1},
    },
};

export const DEFAULT_COLOR = '#6299ff';
export const DEFAULT_OPACITY = 0.5;
